export default __webpack_public_path__ + "images/0x21ada0d2ac28c3a5fa3cd2ee30882da8812279b6.png";